
import MagstimTableData from './MagstimTableData';
import { CurrentLang } from 'common';
import * as StringUtils from 'common/utils/StringUtils.js'

class MagstimTableDataTreatmentPlan extends MagstimTableData {

    getNamedValuePairs(data) {

        let tableData = [];
        //console.log("details getNamedValuePairs", this.props.data);

        tableData = [
            { name: CurrentLang().patient_home_current_plan, value: data.CurrentPlan },
            { name: CurrentLang().patient_home_current_treatment_stage, value: StringUtils.formatStringOrNoData(data.TreatmentStage, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_treatments_completed, value: StringUtils.formatFractionOrNoData(data.TreatmentsCompleted, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_last_treatment, value: StringUtils.formatDateOrNoData(data.LastTreatment, CurrentLang().no_data) },
            { name: CurrentLang().patient_home_last_treatment_by, value: data.LastTreatmentBy }
        ]

        return tableData;
    }
}




export default MagstimTableDataTreatmentPlan;
